import api from '@/api/_prescripteurs'

const copy = value => JSON.parse(JSON.stringify(value))
const rate = value => String(value).trim().replace(',', '.')
const validRate = value => /^(0|[1-9][0-9]{0,2})(\.[0-9]{1,2})?$/.test(rate(value)) && Number(rate(value)) <= 100
const amount = value => String(value === null || value === undefined ? '' : value).trim()
const validAmount = value => /^(0|[1-9][0-9]{0,12})$/.test(amount(value)) && Number(amount(value)) <= 9999999999999
const rulePrestationId = value => value === null || value === undefined || value === '' ? null : Number(value)

export default {
    name: 'PrescripteursExternes',
    data() {
        return { fiches: [], prestations: [], total: 0, page: 1, recherche: '', inactifs: false,
            chargement: false, pret: false, sauvegarde: false, modal: false, brouillon: null, erreur: '', succes: '', lecture: 0 }
    },
    computed: {
        contexte() {
            const auth = this.$store.getters.authInfo || {}, user = auth.user || {}, role = this.$store.getters.activeRole || {}
            return [user.id, auth.access_token, role.nom].join('|')
        },
        autorise() { return (this.$store.getters.activeRole || {}).nom === 'ROLE_ADMINISTRATEUR' },
        pages() { return Math.max(1, Math.ceil(this.total / 25)) },
        anciennesRegles() { return this.brouillon && Number(this.brouillon.schema_version || 1) < 3 },
        peutAjouterRegle() {
            if (!this.brouillon || this.anciennesRegles || this.brouillon.regles.length >= 200) return false
            return this.prestations.some(prestation => {
                const types = [null].concat((prestation.prestations || []).map(type => type.id))
                return types.some(typeId => !this.regleExiste(prestation.categorie, typeId))
            })
        }
    },
    watch: {
        contexte() {
            this.lecture++; this.chargement = false; this.pret = false; this.fiches = []; this.prestations = []; this.brouillon = null; this.modal = false
        }
    },
    mounted() { return this.charger() },
    beforeDestroy() { this.lecture++ },
    methods: {
        valide(contexte) { return !this._isDestroyed && this.autorise && contexte === this.contexte },
        domId(key) { return 'prescripteur-' + this._uid + '-' + key },
        message(error) {
            const response = error.response || {}, data = response.data || {}
            if (response.status === 401 || response.status === 403) return 'Session ou accès expiré. Reconnectez-vous puis réessayez.'
            if (data.errors) return Object.values(data.errors).flat().join(' ')
            return data.message || 'Opération non confirmée. Vérifiez votre connexion et recherchez la fiche avant de réessayer.'
        },
        async charger() {
            if (!this.autorise || this.sauvegarde) return
            const contexte = this.contexte, sequence = ++this.lecture
            this.chargement = true; this.pret = false; this.erreur = ''
            try {
                const token = await api.access()
                if (!this.valide(contexte) || sequence !== this.lecture) return
                const [liste, prestations] = await Promise.all([api.liste({ search: this.recherche, page: this.page, inactifs: this.inactifs ? 1 : 0 }, token), api.catalogue(token)])
                if (!this.valide(contexte) || sequence !== this.lecture) return
                this.fiches = liste.data; this.total = liste.total; this.prestations = prestations; this.pret = true
            } catch (error) { if (this.valide(contexte) && sequence === this.lecture) this.erreur = this.message(error) }
            finally { if (sequence === this.lecture) this.chargement = false }
        },
        rechercher() { this.page = 1; return this.charger() },
        changerPage(page) { if (page < 1 || page > this.pages || this.chargement) return; this.page = page; return this.charger() },
        nouveau() {
            if (!this.pret || !this.autorise || this.sauvegarde) return
            this.brouillon = { schema_version: 3, nom: '', prenoms: '', telephone: '', actif: true, regles: [] }; this.erreur = ''; this.succes = ''; this.modal = true
        },
        editer(fiche) {
            if (!this.pret || !this.autorise || this.sauvegarde) return
            this.brouillon = copy(fiche)
            if (Number(this.brouillon.schema_version) >= 3) this.brouillon.regles.forEach(regle => this.normaliserRegle(regle))
            this.erreur = ''; this.succes = ''; this.modal = true
        },
        remplacerAnciennesRegles() {
            if (this.sauvegarde || !this.anciennesRegles) return
            this.$set(this.brouillon, 'regles_historiques', copy(this.brouillon.regles))
            this.$set(this.brouillon, 'schema_version', 3)
            this.$set(this.brouillon, 'remplacer_anciennes_regles', true)
            this.brouillon.regles = []
        },
        ajouterRegle() {
            if (this.sauvegarde || !this.peutAjouterRegle) return
            this.brouillon.regles.push({ categorie: '', prestation_id: null, mode_remuneration: 'pourcentage', pourcentage: '', base_remuneration: null, montant_fixe: null })
        },
        normaliserRegle(regle) {
            this.$set(regle, 'prestation_id', rulePrestationId(regle.prestation_id))
            this.$set(regle, 'mode_remuneration', regle.mode_remuneration || 'pourcentage')
            this.$set(regle, 'pourcentage', regle.pourcentage === null || regle.pourcentage === undefined ? '' : String(regle.pourcentage))
            this.$set(regle, 'base_remuneration', regle.base_remuneration === null || regle.base_remuneration === undefined ? null : String(regle.base_remuneration))
            this.$set(regle, 'montant_fixe', regle.montant_fixe === null || regle.montant_fixe === undefined ? null : String(regle.montant_fixe))
        },
        typesDe(categorie) {
            return (this.prestations.find(item => item.categorie === categorie) || {}).prestations || []
        },
        typeChoisi(regle) {
            return this.typesDe(regle.categorie).find(type => Number(type.id) === rulePrestationId(regle.prestation_id)) || null
        },
        regleExiste(categorie, prestationId, ignore) {
            if (!this.brouillon) return false
            const type = rulePrestationId(prestationId)
            return this.brouillon.regles.some(regle => regle !== ignore && regle.categorie === categorie && rulePrestationId(regle.prestation_id) === type)
        },
        categorieIndisponible(prestation, regle) {
            if (regle.categorie === prestation.categorie) return false
            const types = [null].concat((prestation.prestations || []).map(type => type.id))
            return !types.some(typeId => !this.regleExiste(prestation.categorie, typeId, regle))
        },
        choisirCategorie(regle, key) {
            const prestation = this.prestations.find(item => item.categorie === key)
            if (!prestation || this.sauvegarde) return
            this.$set(regle, 'categorie', prestation.categorie)
            const typeDisponible = (prestation.prestations || []).find(type => !this.regleExiste(prestation.categorie, type.id, regle))
            const prestationId = this.regleExiste(prestation.categorie, null, regle) && typeDisponible ? typeDisponible.id : null
            this.$set(regle, 'prestation_id', prestationId)
            this.$set(regle, 'base_remuneration', null)
            this.$set(regle, 'montant_fixe', regle.mode_remuneration === 'montant_fixe' ? regle.montant_fixe || '' : null)
            if (regle.mode_remuneration !== 'montant_fixe') {
                this.$set(regle, 'mode_remuneration', 'pourcentage')
                this.$set(regle, 'pourcentage', regle.pourcentage === null ? '' : regle.pourcentage)
                const type = this.typeChoisi(regle)
                this.$set(regle, 'base_remuneration', type ? String(type.montant) : null)
            }
        },
        choisirPrestation(regle, value) {
            if (this.sauvegarde) return
            const prestationId = rulePrestationId(value)
            this.$set(regle, 'prestation_id', prestationId)
            if (regle.mode_remuneration !== 'pourcentage') return
            const type = this.typeChoisi(regle)
            this.$set(regle, 'base_remuneration', type ? String(type.montant) : null)
        },
        choisirMode(regle, mode) {
            if (this.sauvegarde) return
            this.$set(regle, 'mode_remuneration', mode)
            if (mode === 'montant_fixe') {
                this.$set(regle, 'pourcentage', null)
                this.$set(regle, 'base_remuneration', null)
                this.$set(regle, 'montant_fixe', regle.montant_fixe || '')
                return
            }
            this.$set(regle, 'montant_fixe', null)
            this.$set(regle, 'pourcentage', regle.pourcentage === null ? '' : regle.pourcentage)
            const type = this.typeChoisi(regle)
            this.$set(regle, 'base_remuneration', type ? String(type.montant) : null)
        },
        libelleRegleHistorique(regle) {
            return regle.prestation_libelle || regle.libelle || regle.categorie || regle.prestation_type || '—'
        },
        versionRegles(fiche) {
            return Number(fiche.schema_version || 1)
        },
        valeurRegleHistorique(regle) {
            if (regle.mode_remuneration === 'montant_fixe') return (regle.montant_fixe || 0) + ' CDF fixes'
            return (regle.pourcentage || 0) + ' %'
        },
        erreurValidation() {
            const draft = this.brouillon
            if (!draft || !draft.nom.trim() || !draft.prenoms.trim()) return 'Renseignez le nom et les prénoms.'
            if (this.anciennesRegles) return 'Créez une version V3 avant d’enregistrer.'
            const seen = new Set()
            for (const rule of draft.regles) {
                const categorie = this.prestations.find(item => item.categorie === rule.categorie)
                if (!categorie) return 'Choisissez une catégorie disponible.'
                const prestationId = rulePrestationId(rule.prestation_id)
                const type = prestationId === null ? null : (categorie.prestations || []).find(item => Number(item.id) === prestationId)
                if (prestationId !== null && !type) return 'Choisissez un type tarifé dans cette catégorie.'
                const key = categorie.categorie + ':' + (prestationId === null ? 'tout' : prestationId)
                if (seen.has(key)) return 'Une seule règle est autorisée pour cette catégorie et ce type.'
                seen.add(key)
                if (rule.mode_remuneration === 'pourcentage') {
                    if (!validRate(rule.pourcentage)) return 'Le taux doit être compris entre 0 et 100 %, avec deux décimales maximum.'
                    if (amount(rule.montant_fixe)) return 'Le montant fixe ne s’applique pas à une règle au pourcentage.'
                    if (type) {
                        if (!validAmount(rule.base_remuneration)) return 'La base doit être un montant entier positif ou nul.'
                        if (Number(amount(rule.base_remuneration)) > Number(type.montant)) return 'La base ne peut pas dépasser le P.U. du type choisi.'
                    } else if (amount(rule.base_remuneration)) return 'La base est disponible uniquement pour un type précis.'
                } else if (rule.mode_remuneration === 'montant_fixe') {
                    if (!validAmount(rule.montant_fixe)) return 'Le montant fixe doit être un montant entier positif ou nul.'
                    if (amount(rule.pourcentage) || amount(rule.base_remuneration)) return 'Le pourcentage et la base ne s’appliquent pas à une règle au montant fixe.'
                } else return 'Choisissez un mode de rémunération.'
            }
            return ''
        },
        async enregistrer() {
            if (!this.autorise || this.sauvegarde || !this.brouillon) return
            this.erreur = this.erreurValidation(); if (this.erreur) return
            const contexte = this.contexte, draft = copy(this.brouillon)
            draft.schema_version = 3
            delete draft.regles_historiques
            draft.regles = draft.regles.map(rule => {
                const prestationId = rulePrestationId(rule.prestation_id)
                return {
                    categorie: rule.categorie,
                    prestation_id: prestationId,
                    mode_remuneration: rule.mode_remuneration,
                    pourcentage: rule.mode_remuneration === 'pourcentage' ? rate(rule.pourcentage) : null,
                    base_remuneration: rule.mode_remuneration === 'pourcentage' && prestationId !== null ? Number(amount(rule.base_remuneration)) : null,
                    montant_fixe: rule.mode_remuneration === 'montant_fixe' ? Number(amount(rule.montant_fixe)) : null
                }
            })
            this.sauvegarde = true
            try {
                const token = await api.access()
                if (!this.valide(contexte)) return
                await api.enregistrer(draft, token)
                if (!this.valide(contexte)) return
                this.modal = false; this.brouillon = null; this.succes = 'Prescripteur enregistré.'
            } catch (error) { if (this.valide(contexte)) this.erreur = this.message(error) }
            finally { this.sauvegarde = false }
            if (this.valide(contexte) && !this.brouillon) await this.charger()
        }
    }
}
